import React from 'react';

import { SxProp } from 'src/types/mui';

export const DASHBOARD_FILTER_CV_ADMIN_BUTTON_STYLES: React.CSSProperties = {
  textTransform: 'none',
  fontWeight: 'normal',
  fontSize: 16,
  paddingTop: 0,
  paddingBottom: 0,
  lineHeight: 1.5,
};

export const DASHBOARD_FILTER_CV_ADMIN_BUTTON_END_ICON_STYLES: SxProp = {
  '& .MuiButton-endIcon': {
    ml: 2,
  },
};
